// Verified data for Viraj Gavade Portfolio

export const personalInfo = {
  name: "VIRAJ GAVADE",
  headline: "Software Developer · AI/ML · GenAI",
  tagline: "Building things that actually ship",
  description: "Software developer focused on AI/ML, Generative AI and full-stack development.",
  portfolio: "https://portfolio-viraj-gavades-projects.vercel.app/",
  linkedin: "https://www.linkedin.com/in/viraj-gavade-8877aa30b/",
  github: "https://github.com/viraj-gavade",
  twitter: "https://x.com/viraj_gavade",
  email: "vrajgavade17@gmail.com",
  resumes: {
    ml: "https://drive.google.com/file/d/14ZciY67_Bl874VOAtNvVIfXM0deVXjrX/view?usp=sharing",
    fullstack: "https://drive.google.com/file/d/1mSombCeDRLcZg-_0IAvvmlQq_dELe-6n/view?usp=sharing",
    ai: "https://drive.google.com/file/d/1h0XPVvvoFqMnFxoinpQZG00nQbII-D0K/view?usp=sharing",
    aiml: "https://drive.google.com/file/d/11bGrPk8WNSWPR3GU97VvXgssoZYhm2-K/view?usp=sharing"
  }
};

export const metrics = {
  repositories: "70+",
  stars: "4",
  followers: "11",
  following: "5",
  projects: "20+",
  technologies: "40+",
  certifications: "7+",
  years: "2+"
};

export const experience = [
  {
    id: 1,
    role: "Software Developer Intern",
    company: "LivingThings.ai",
    period: "2026 — Present",
    description: [
      "Currently working as a Software Developer Intern at LivingThings.ai."
    ],
    tech: []
  }
];

export const timeline = [
  {
    id: 1,
    period: "Feb 2024",
    title: "Web Development Journey Begins",
    description: "Started learning HTML, CSS, and JavaScript fundamentals",
    icon: "🚀",
    skills: ["HTML", "CSS", "JavaScript"],
    projects: [],
    type: "milestone"
  },
  {
    id: 2,
    period: "Aug 2024",
    title: "Backend Development & Tech Stack",
    description: "Learned server-side development with Node.js, Express, and database design",
    icon: "🔧",
    skills: ["Node.js", "Express", "MongoDB", "REST APIs"],
    projects: [],
    type: "skill"
  },
  {
    id: 3,
    period: "Nov 2024",
    title: "React & Frontend Mastery",
    description: "Deep dive into React, component design, state management, and responsive UI",
    icon: "⚛️",
    skills: ["React", "JSX", "Hooks", "Tailwind CSS"],
    projects: [],
    type: "skill"
  },
  {
    id: 4,
    period: "Dec 2024",
    title: "Full Stack Development",
    description: "Completed full-stack MERN applications with authentication and cloud deployment",
    icon: "🌐",
    skills: ["MERN Stack", "TypeScript", "AWS S3", "Socket.io"],
    projects: ["StudyShare", "Thriftify", "Secure-Vault"],
    type: "project"
  },
  {
    id: 5,
    period: "Mar 2025",
    title: "Machine Learning Specialization",
    description: "Completed comprehensive ML specialization from DeepLearning.AI",
    icon: "🎓",
    skills: ["PyTorch", "Neural Networks", "Scikit-learn", "TensorFlow"],
    projects: [],
    type: "certification"
  },
  {
    id: 6,
    period: "Aug 2025",
    title: "GenAI Professional Certification",
    description: "Achieved OCI Certified Generative AI Professional certification",
    icon: "🎓",
    skills: ["LangChain", "RAG", "LLMs", "Prompt Engineering"],
    projects: ["Conversational RAG Chatbot"],
    type: "certification"
  },
  {
    id: 8,
    period: "Nov 2025",
    title: "MLOps & AWS Deployment",
    description: "Mastered MLOps practices, Docker containerization, and AWS cloud infrastructure",
    icon: "☁️",
    skills: ["Docker", "MLflow", "AWS EC2", "CI/CD Pipelines"],
    projects: ["Network Intrusion Detection", "Heart Disease Prediction"],
    type: "project"
  },
  {
    id: 9,
    period: "Jan 2026",
    title: "AI Automation with N8N",
    description: "Built intelligent automation workflows using N8N and AI agents",
    icon: "🤖",
    skills: ["N8N", "Groq LLM", "API Integration", "Workflow Automation"],
    projects: ["Travel Planner AI Agent", "AI Automation Pipelines"],
    type: "project"
  }
];

export const projects = [
  {
    id: 1,
    title: "Thriftify",
    subtitle: "E-commerce Platform",
    description: "Full-stack e-commerce platform with real-time features and payment integration",
    longDescription: "Built a comprehensive e-commerce platform using Node.js, Express, and MongoDB. Implemented real-time communication with Socket.io, secure authentication with JWT, and integrated PayPal payment gateway. Features include product management, user authentication, and order processing with a complete shopping experience.",
    tech: ["Node.js", "Express", "MongoDB", "Socket.io", "JWT", "PayPal API"],
    github: "https://github.com/viraj-gavade/Thriftify",
    demo: "https://thriftify.onrender.com/",
    image: "/images/projects/project-01-image.png",
    category: "Full Stack",
    highlights: [
      "Real-time WebSocket communication for live updates",
      "Secure JWT-based authentication system",
      "PayPal payment gateway integration",
      "Complete RESTful API architecture",
      "Product management and inventory system",
      "Order processing and tracking"
    ]
  },
  {
    id: 2,
    title: "StudyShare",
    subtitle: "Resource Sharing Platform",
    description: "MERN stack platform for sharing and managing educational resources",
    longDescription: "Developed a comprehensive resource sharing platform using the MERN stack with TypeScript. Integrated AWS S3 for scalable file storage and implemented type-safe React components. Features include file upload/download, user management, resource categorization, and a robust search system for educational materials.",
    tech: ["React", "TypeScript", "Node.js", "MongoDB", "AWS S3", "Express"],
    github: "https://github.com/viraj-gavade/STUDY-SHARE",
    demo: "https://study-share-frontend.onrender.com/",
    image: "/images/projects/study-share.png",
    category: "Full Stack",
    highlights: [
      "Type-safe React components with TypeScript",
      "AWS S3 integration for scalable file storage",
      "Complete MERN stack architecture",
      "Resource management and categorization system",
      "Advanced search and filtering capabilities",
      "User authentication and authorization"
    ]
  },
  {
    id: 3,
    title: "Heart Disease Prediction",
    subtitle: "Healthcare ML Application",
    description: "ML-powered platform predicting cardiovascular risk from health metrics",
    longDescription: "Developed a production healthcare application with Logistic Regression model for cardiovascular risk prediction. Processed 13+ clinical features including age, blood pressure, cholesterol levels, and other health indicators. Built interactive visualizations with Chart.js for result interpretation and deployed with Docker on Render for accessibility.",
    tech: ["Python", "Scikit-learn", "Logistic Regression", "Docker", "Chart.js", "Render"],
    github: "https://github.com/viraj-gavade/Heart-disease-Prediction-using-Machine-Learning",
    demo: "https://heart-disease-prediction-t0j1.onrender.com/",
    image: "/images/projects/Heart-Disease.png",
    category: "ML",
    highlights: [
      "Logistic Regression model for risk prediction",
      "Processing 13+ clinical health features",
      "Interactive visualizations with Chart.js",
      "Docker containerization for deployment",
      "Render cloud deployment",
      "User-friendly interface for medical insights"
    ]
  },
  {
    id: 4,
    title: "Secure-Vault",
    subtitle: "Password Manager",
    description: "Privacy-focused password manager with client-side encryption",
    longDescription: "Built a security-focused password manager using Next.js and TypeScript. Implemented AES-256 client-side encryption ensuring zero server-side knowledge of passwords. Features include secure credential storage, password generation, and minimal fast UI with Next.js optimization.",
    tech: ["Next.js", "TypeScript", "MongoDB", "Crypto-JS", "Tailwind CSS"],
    github: "https://github.com/viraj-gavade/Secure-Valut",
    demo: "https://secure-valut.vercel.app",
    image: "/images/projects/secure-vault.png",
    category: "Full Stack",
    highlights: [
      "AES-256 client-side encryption",
      "Zero-knowledge architecture",
      "Next.js with TypeScript",
      "Security-focused design",
      "Password generation features",
      "Vercel deployment"
    ]
  },
  {
    id: 5,
    title: "Aerial Object Classification",
    subtitle: "Computer Vision System",
    description: "YOLO-based object detection for aerial imagery analysis",
    longDescription: "Developed computer vision system for aerial object detection using YOLO and custom CNN architectures. Built data augmentation pipeline and trained on bird vs drone classification dataset. Features include real-time detection, custom model training, and Streamlit interface with detailed documentation available.",
    tech: ["PyTorch", "YOLO", "OpenCV", "Streamlit", "Computer Vision"],
    github: "https://github.com/viraj-gavade/Aerial-Object-Classification---Detection",
    docs: "https://drive.google.com/file/d/1rqIkqUzKbRCrLXxscRBIa36Ae3DJ-4_E/view?usp=sharing",
    demo: null,
    image: "/images/projects/Aerial-Object-Classifier.png",
    category: "ML",
    highlights: [
      "YOLO object detection implementation",
      "Custom CNN architecture for classification",
      "Data augmentation pipeline for robust training",
      "Real-time inference capabilities",
      "Bird vs drone classification",
      "Comprehensive documentation"
    ]
  },
  {
    id: 6,
    title: "EMI Predictor",
    subtitle: "Financial ML Application",
    description: "Machine learning application for predicting loan EMI and financial planning",
    longDescription: "Built a financial planning application using machine learning algorithms to predict Equated Monthly Installments (EMI) for loans. Implemented multiple ML models including Linear Regression and Decision Trees for accurate predictions. Features include loan comparison, amortization schedules, and interactive visualizations.",
    tech: ["Python", "Scikit-learn", "Linear Regression", "Decision Trees", "Streamlit"],
    github: "https://github.com/viraj-gavade/EMI-predictor",
    docs: "https://drive.google.com/file/d/1Gs_ChrggqEWzw2wAPWh9-Rasxifq1NrD/view?usp=sharing",
    image: "/images/projects/Emi-predictor.png",
    category: "ML",
    highlights: [
      "Multiple ML models for EMI prediction",
      "Loan comparison functionality",
      "Amortization schedule generation",
      "Interactive financial visualizations",
      "Streamlit user interface",
      "Comprehensive documentation"
    ]
  },
  {
    id: 7,
    title: "Conversational RAG Chatbot",
    subtitle: "GenAI Document Assistant",
    description: "RAG-powered chatbot with document understanding and conversation memory",
    longDescription: "Built a Retrieval-Augmented Generation system using LangChain and ChromaDB. Implemented document embedding pipeline with HuggingFace models and stateful conversation management. Features include PDF upload, intelligent document retrieval, and context-aware responses for enhanced user experience.",
    tech: ["Python", "LangChain", "ChromaDB", "HuggingFace", "Streamlit"],
    github: "https://github.com/viraj-gavade/End-to-end-Conversational-chatbot-with-pdf-and-chat-history",
    demo: "https://rag-document-app.streamlit.app/",
    image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&q=80",
    category: "GenAI",
    highlights: [
      "RAG architecture implementation",
      "Vector database integration with ChromaDB",
      "Document embedding pipeline",
      "Stateful conversation memory",
      "PDF upload and processing",
      "Context-aware response generation"
    ]
  },
  {
    id: 8,
    title: "Forest Fire Prediction",
    subtitle: "Environmental ML System",
    description: "Machine learning system for predicting forest fire risk based on environmental factors",
    longDescription: "Developed an environmental monitoring system using machine learning to predict forest fire risks. Analyzed multiple environmental factors including temperature, humidity, wind speed, and rainfall patterns. Implemented classification models for risk assessment and deployed with real-time monitoring capabilities.",
    tech: ["Python", "Scikit-learn", "Random Forest", "Pandas", "Matplotlib"],
    github: "https://github.com/viraj-gavade/ForestFire-Prediction",
    image: "/images/projects/ForestFire.png",
    category: "ML",
    highlights: [
      "Environmental factor analysis",
      "Random Forest classification model",
      "Real-time risk assessment",
      "Data visualization with Matplotlib",
      "Weather pattern integration",
      "Environmental monitoring dashboard"
    ]
  },
  {
    id: 9,
    title: "Car Price Prediction",
    subtitle: "Automotive ML Application",
    description: "Machine learning application for predicting car prices based on vehicle features",
    longDescription: "Built an automotive pricing prediction system using machine learning algorithms. Analyzed vehicle features including make, model, year, mileage, engine specifications, and condition. Implemented regression models for accurate price estimation and feature importance analysis.",
    tech: ["Python", "Scikit-learn", "Linear Regression", "Random Forest", "XGBoost"],
    github: "https://github.com/viraj-gavade/Car-Price-Prediction",
    image: "/images/projects/car-price-prediction.png",
    category: "ML",
    highlights: [
      "Multiple regression model implementation",
      "Vehicle feature analysis",
      "Price estimation algorithms",
      "Feature importance analysis",
      "Market trend integration",
      "Predictive accuracy optimization"
    ]
  }
];

export const skills = {
  "Languages": [
    { name: "JavaScript", icon: "FaJs" },
    { name: "Python", icon: "FaPython" },
    { name: "TypeScript", icon: "SiTypescript" },
    { name: "HTML", icon: "FaHtml5" },
    { name: "CSS", icon: "FaCss3Alt" },
    { name: "JSX", icon: "FaReact" }
  ],
  "AI / Machine Learning": [
    { name: "PyTorch", icon: "SiPytorch" },
    { name: "Scikit-learn", icon: "SiScikitlearn" },
    { name: "TensorFlow", icon: "SiTensorflow" },
    { name: "Keras", icon: "SiTensorflow" },
    { name: "Computer Vision", icon: "SiOpencv" },
    { name: "NLP", icon: "SiOpenai" },
    { name: "OpenCV", icon: "SiOpencv" },
    { name: "YOLO", icon: "SiOpencv" },
    { name: "CNN", icon: "SiPytorch" },
    { name: "Linear Regression", icon: "SiScikitlearn" },
    { name: "Logistic Regression", icon: "SiScikitlearn" },
    { name: "Random Forest", icon: "SiScikitlearn" },
    { name: "Decision Trees", icon: "SiScikitlearn" },
    { name: "XGBoost", icon: "SiScikitlearn" },
    { name: "Pandas", icon: "SiPandas" },
    { name: "NumPy", icon: "SiNumpy" },
    { name: "Matplotlib", icon: "SiPython" }
  ],
  "Generative AI": [
    { name: "RAG", icon: "SiLangchain" },
    { name: "HuggingFace", icon: "SiHuggingface" },
    { name: "LLMs", icon: "SiOpenai" },
    { name: "Vector Databases", icon: "SiMongodb" },
    { name: "LangChain", icon: "SiLangchain" },
    { name: "ChromaDB", icon: "SiMongodb" },
    { name: "Prompt Engineering", icon: "SiOpenai" },
    { name: "Gemini API", icon: "SiOpenai" },
    { name: "Streamlit", icon: "FaPython" }
  ],
  "Frontend": [
    { name: "React", icon: "FaReact" },
    { name: "Next.js", icon: "SiNextdotjs" },
    { name: "Tailwind CSS", icon: "SiTailwindcss" },
    { name: "TypeScript", icon: "SiTypescript" },
    { name: "JSX", icon: "FaReact" },
    { name: "EJS", icon: "FaNodeJs" },
    { name: "Chart.js", icon: "FaCode" },
    { name: "Framer Motion", icon: "FaCode" },
    { name: "Lucide React", icon: "FaCode" }
  ],
  "Backend": [
    { name: "Node.js", icon: "FaNodeJs" },
    { name: "Express", icon: "SiExpress" },
    { name: "FastAPI", icon: "FaPython" },
    { name: "MongoDB", icon: "SiMongodb" },
    { name: "Mongoose", icon: "SiMongodb" },
    { name: "Socket.io", icon: "FaNodeJs" },
    { name: "JWT", icon: "FaLock" },
    { name: "REST APIs", icon: "FaServer" },
    { name: "GraphQL", icon: "SiGraphql" },
    { name: "Crypto-JS", icon: "FaLock" },
    { name: "PayPal API", icon: "FaServer" }
  ],
  "Cloud / DevOps": [
    { name: "AWS S3", icon: "FaAws" },
    { name: "Docker", icon: "FaDocker" },
    { name: "Render", icon: "SiRender" },
    { name: "Vercel", icon: "SiVercel" },
    { name: "Git", icon: "FaGitAlt" },
    { name: "GitHub", icon: "FaGithub" },
    { name: "CI/CD", icon: "FaCloud" },
    { name: "MLflow", icon: "FaPython" }
  ],
  "Security": [
    { name: "AES-256", icon: "FaLock" },
    { name: "JWT", icon: "FaLock" },
    { name: "OAuth", icon: "FaLock" },
    { name: "Encryption", icon: "FaLock" },
    { name: "Authentication", icon: "FaLock" },
    { name: "Zero-knowledge", icon: "FaLock" }
  ],
  "Databases": [
    { name: "MongoDB", icon: "SiMongodb" },
    { name: "Mongoose", icon: "SiMongodb" },
    { name: "PostgreSQL", icon: "SiPostgresql" },
    { name: "Vector Databases", icon: "SiMongodb" },
    { name: "ChromaDB", icon: "SiMongodb" }
  ],
  "Development Tools": [
    { name: "VS Code", icon: "FaCode" },
    { name: "Git", icon: "FaGitAlt" },
    { name: "GitHub", icon: "FaGithub" },
    { name: "Postman", icon: "FaServer" },
    { name: "Docker", icon: "FaDocker" },
    { name: "npm", icon: "FaNodeJs" },
    { name: "yarn", icon: "FaNodeJs" }
  ]
};

export const certifications = [
  {
    id: 1,
    title: "OCI 2025 Certified Generative AI Professional",
    issuer: "Oracle",
    date: "August 29, 2025",
    link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=C1581D76C9B19EA7DD25C7E0D0A57626B4084DE7F3D3D1876D86990E100AEC3D",
    category: "AI",
    image: "/images/certifications/OCI-GENAI-PROFESSIONAL.png"
  },
  {
    id: 2,
    title: "Machine Learning Specialization",
    issuer: "DeepLearning.AI",
    date: "March 2025",
    link: "https://coursera.org/share/16418c4b4fee42012a01c5e69c7badc5",
    category: "ML",
    image: "/images/certifications/Machine-learning.specilization.png"
  },
  {
    id: 3,
    title: "OCI 2025 Certified AI Foundations Associate",
    issuer: "Oracle",
    date: "August 25, 2025",
    link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=A9319E065260D1AD88B8C2FF33925A707E7B4639148705740C474E4DF6AA75A8",
    category: "AI",
    image: "/images/certifications/oci-geni-ai-foundations.png"
  },
  {
    id: 4,
    title: "Generative AI Engineering with LLMs",
    issuer: "IBM",
    date: "2026",
    link: "https://coursera.org/share/1589e3d552f2dcc6a2fca68be2ba8f40",
    category: "AI",
    image: "/images/certifications/ibm-genai-engineering.jpeg"
  },
  {
    id: 5,
    title: "Python for Data Science, AI & Development",
    issuer: "IBM",
    date: "February 2025",
    link: "https://www.coursera.org/account/accomplishments/verify/DYJDEFMYBCJN",
    category: "Data Science",
    image: "/images/certifications/Python-for-Data-Science-AI-&-Development.png"
  },
  {
    id: 6,
    title: "Deep Learning with PyTorch, Keras and TensorFlow",
    issuer: "IBM",
    date: "2026",
    link: "https://coursera.org/share/26e3fc3f4a5f1f711cabe29abb5fe17f",
    category: "Deep Learning",
    image: "/images/certifications/ibm-deep-learning-with-pytorch-keras-tensorflow.jpeg"
  },
  {
    id: 7,
    title: "IBM AI Engineering",
    issuer: "IBM",
    date: "May 2026",
    link: "https://coursera.org/share/43f7d41d2fcccc3b207d9e01864a5594",
    category: "AI",
    image: "/images/certifications/IBM-AI-ENGINEERING.png"
  }
];
